
(function () {
	function getPageCategory() {
		const path = window.location.pathname.toLowerCase();
		const locale = path.match(/\/(es-es|pt-pt)\//)?.[1] || 'es-es';

		if(document.body.classList.contains('error404')) {
			return 'other';
		}
		
		// Home
		if (path === `/${locale}/` || path === `/${locale}`) {
			return 'home';
		}
		
		// Gimnasios
		if (path.includes('/gimnasios/') || path.includes('/ginasios/')) {
			const pathSegment = path.includes('/gimnasios/') ? '/gimnasios/' : '/ginasios/';
			const parts = path.split(pathSegment)[1]?.split('/').filter(Boolean);
			if (parts && parts.length === 1) {
				return 'provincia';
			}
			return 'clubs';
		}
		
		// Cuotas y Servicios
		if (path.includes('/cuotas/') || 
			path.includes('/one-experience') ||
			path.includes('/personal-training') ||
			path.includes('/the-boxer-club') ||
			path.includes('/agua-vitaminada') ||
			path.includes('/alquiler-de-taquillas') ||
			// TODO: add the pt-pt equivalents when available
			path.includes('/quotas/')) {
			return 'cuotas_y_servicios';
		}
		
		// Clases
		if (path.includes('/clases/') || path.includes('/classes/')) {
			return 'clases';
		}
		
		// Blog
		if (path.includes('/blog/')) {
			return 'blog';
		}
		if(document.querySelector('.site-main-blog--single')) {
			return 'blog';
		}
		
		// Joining Funnel
		if (path.includes('/joining')) {
			return 'joining';
		}
		
		// Corporate y Legal
		if (path.includes('/zonas/') ||
			isFooterMenuPage()) {
			return 'corporate';
		}

		return 'other';
	}

	function isFooterMenuPage() {
		const currentPath = window.location.pathname.toLowerCase();
		const footerMenus = document.querySelectorAll('.site-footer');
		const footerLinks = [];
		
		footerMenus.forEach(menu => {
			const links = menu.querySelectorAll('a[href]');
			links.forEach(link => {
				const url = new URL(link.href);
				footerLinks.push(url.pathname.toLowerCase());
			});
		});

		return footerLinks.some(footerPath => {
			return footerPath === currentPath;
		});
	}

	function loadCampaignParameter(){
		const urlParams = new URLSearchParams(window.location.search);
		let campaign = urlParams.get('utm_campaign');

		if (!campaign) {
			if (sessionStorage.getItem('vg_utm_campaign')) {
				return;
			}
			const referrer = document.referrer || '';

			if (!referrer) {
				campaign = 'direct/none';

			} else {
				const searchEngines = [
					'google.',
					'bing.com',
					'yahoo.',
					'duckduckgo.com',
					'ecosia.org'
				];

				const isSearchEngine = searchEngines.some(engine =>
					referrer.includes(engine)
				);

				if (isSearchEngine) {
					campaign = 'organic';
				} else {
					campaign = 'direct/none';
				}
			}
		}

		sessionStorage.setItem('vg_utm_campaign', campaign);
	}


	document.addEventListener("DOMContentLoaded", () => {
		loadCampaignParameter();

		let clubId = document.querySelector('[data-gym-id]')?.getAttribute('data-gym-id') || '';
		let clubName = document.querySelector('[data-gym-label]')?.getAttribute('data-gym-label') || '';

		VgGtm.pushRegisterEventToDataLayer(
			'page_viewed',
			{},
			{
				page_category: getPageCategory(),
				login_status: 'logged_out',
				club_id: clubId,
				club_name: clubName,
			}
		);
	});
})();